// extracted by mini-css-extract-plugin
export default {"SearchTextField--dark":"K1oqQuVG2OgDUrSfdPWQ","clearIcon":"WMFi3bRks6AHsu20X0Nq"};